module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOCAMAAAB5Au6AAAAAElBMVEV7/xhCSlpaY3uEe3P///+EhKVyJiYHAAAAAXRSTlMAQObYZgAAAF5JREFUeNqNj1EOwDAIQrG297/ylimO+WHGh4nlhQpwRgFnjTrQbVPyBrWdEgRqR8g9BXkBZ0ggHQj/CXFXooAabfkNZOyOQ/jnt0Vezza9Ba93tiFgS5FU2csAG4ULVbgEZHcPzfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/categories/Special.png
// module id = 176
// module chunks = 0